import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=3aad3564&"
import script from "./Team.vue?vue&type=script&lang=ts&"
export * from "./Team.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aad3564')) {
      api.createRecord('3aad3564', component.options)
    } else {
      api.reload('3aad3564', component.options)
    }
    module.hot.accept("./Team.vue?vue&type=template&id=3aad3564&", function () {
      api.rerender('3aad3564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/Team.vue"
export default component.exports